module.exports = __webpack_public_path__ + "28b67065/img/settings-ico.a214628d.svg";